import axios from 'axios';
//change to istg/prod
const APIUrl = 'https://istg-digital-chatcon.elysium-dfbt.com/connector/v3/sendUserMessage'

interface SendMessagePayload {
    conversationSid : string,
    messageBody: string,
    author: string
}

export const sendOnHoldMessage = async (payload: SendMessagePayload): Promise<unknown> => {
    try {
        await axios.post(APIUrl, {
            contextParameters: payload,
        });
        return console.log('On hold message posted')
    } catch (e) {
        console.error("On hold message error", e);
        return null;
    }
};
